(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5995);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



var Footer = function() {
    var BRAND_NAME = "PottersTouch LLC - Healthcare & Transportation Services";
    var footerNavigation = {
        company: [
            {
                name: "About",
                href: "/about-us"
            }
        ],
        legal: [
            {
                name: "Privacy",
                href: "/privacy"
            },
            {
                name: "Terms",
                href: "/terms"
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "bg-gray-50 px-4 py-12 mt-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-7xl mx-auto text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-wrap justify-center gap-4 mb-8",
                    children: [
                        footerNavigation.company.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: item.href,
                                prefetch: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-base text-gray-500 hover:text-gray-700",
                                    children: item.name
                                })
                            }, item.name);
                        }),
                        footerNavigation.legal.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: item.href,
                                prefetch: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-base text-gray-500 hover:text-gray-700",
                                    children: item.name
                                })
                            }, item.name);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-base text-gray-400",
                    children: [
                        "\xa9 ",
                        new Date().getFullYear(),
                        " ",
                        BRAND_NAME,
                        ". All rights reserved."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 8969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(158);
/* harmony import */ var _lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5830);






var Header = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Popover */ .J, {
            className: "relative bg-white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mx-auto flex max-w-7xl items-center justify-between px-4 py-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-start lg:w-0 lg:flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Your Company"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: _lib__WEBPACK_IMPORTED_MODULE_5__/* .BRAND_IMAGE */ .J3,
                                        alt: "logo",
                                        width: 100,
                                        height: 100,
                                        blurDataURL: _lib__WEBPACK_IMPORTED_MODULE_5__/* .BRAND_IMAGE */ .J3,
                                        placeholder: "blur"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "items-center justify-end md:flex md:flex-1 lg:w-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "https://api.whatsapp.com/send?phone=13476540706",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "ml-8 inline-flex items-center justify-center whitespace-nowrap rounded-md border border-transparent bg-gradient-to-r from-cyan-600 to-cyan-600 bg-origin-border px-4 py-2 text-base font-medium text-white shadow-sm hover:from-cyan-700 hover:to-cyan-700",
                                children: "WhatsApp Us"
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 5830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ BRAND_URL; },
/* harmony export */   "CO": function() { return /* binding */ BRAND_DESCRIPTION; },
/* harmony export */   "J3": function() { return /* binding */ BRAND_IMAGE; },
/* harmony export */   "RS": function() { return /* binding */ BRAND_NAME; },
/* harmony export */   "iO": function() { return /* binding */ BRAND_TAGLINE; },
/* harmony export */   "m4": function() { return /* binding */ BRAND_EMAIL; }
/* harmony export */ });
/* unused harmony exports BRAND_FAVICON, classNames */
var BRAND_NAME = "PottersTouch LLC - Child-Centric Healthcare & Transportation Services";
var BRAND_TAGLINE = "Prioritizing the Health and Safety of Our Young Clients";
var BRAND_DESCRIPTION = "PottersTouch LLC excels in delivering top-tier, child-focused post-acute, long-term care, and transportation services. Our dedicated team of empathetic professionals provides exceptional clinical and transport solutions. While we specialize in children's healthcare, we extend our services to all age groups, ensuring an environment of safety, healing, and overall wellness.";
var BRAND_URL = "https://www.potterstouch.org";
var BRAND_EMAIL = "potterstouchagency@gmail.com";
var BRAND_IMAGE = "https://res.cloudinary.com/deyudesls/image/upload/v1667430480/rounded%20logo.webp";
var BRAND_FAVICON = "/android-chrome-192x192.png";
var classNames = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
};


/***/ }),

/***/ 5995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./lib/index.ts
var lib = __webpack_require__(5830);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/HomeIcon.js

function HomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
  }));
}
const ForwardRef = react.forwardRef(HomeIcon);
/* harmony default export */ var esm_HomeIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/BuildingOffice2Icon.js

function BuildingOffice2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
  }));
}
const BuildingOffice2Icon_ForwardRef = react.forwardRef(BuildingOffice2Icon);
/* harmony default export */ var esm_BuildingOffice2Icon = (BuildingOffice2Icon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/UsersIcon.js

function UsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
  }));
}
const UsersIcon_ForwardRef = react.forwardRef(UsersIcon);
/* harmony default export */ var esm_UsersIcon = (UsersIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/TruckIcon.js

function TruckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
  }));
}
const TruckIcon_ForwardRef = react.forwardRef(TruckIcon);
/* harmony default export */ var esm_TruckIcon = (TruckIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/BellAlertIcon.js

function BellAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"
  }));
}
const BellAlertIcon_ForwardRef = react.forwardRef(BellAlertIcon);
/* harmony default export */ var esm_BellAlertIcon = (BellAlertIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/CheckCircleIcon.js

function CheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}
const CheckCircleIcon_ForwardRef = react.forwardRef(CheckCircleIcon);
/* harmony default export */ var esm_CheckCircleIcon = (CheckCircleIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/InformationCircleIcon.js

function InformationCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
  }));
}
const InformationCircleIcon_ForwardRef = react.forwardRef(InformationCircleIcon);
/* harmony default export */ var esm_InformationCircleIcon = (InformationCircleIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/20/solid/esm/ShieldCheckIcon.js

function ShieldCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9.661 2.237a.531.531 0 01.678 0 11.947 11.947 0 007.078 2.749.5.5 0 01.479.425c.069.52.104 1.05.104 1.59 0 5.162-3.26 9.563-7.834 11.256a.48.48 0 01-.332 0C5.26 16.564 2 12.163 2 7c0-.538.035-1.069.104-1.589a.5.5 0 01.48-.425 11.947 11.947 0 007.077-2.75zm4.196 5.954a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    clipRule: "evenodd"
  }));
}
const ShieldCheckIcon_ForwardRef = react.forwardRef(ShieldCheckIcon);
/* harmony default export */ var esm_ShieldCheckIcon = (ShieldCheckIcon_ForwardRef);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/Meta.tsx



var MetaComponent = function(param) {
    var title = param.title, description = param.description, image = param.image, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title || lib/* BRAND_NAME */.RS
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "title",
                    content: lib/* BRAND_TAGLINE */.iO
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: description || lib/* BRAND_DESCRIPTION */.CO
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:type",
                    content: "website"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:url",
                    content: url || lib/* BRAND_URL */.$1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:title",
                    content: title || lib/* BRAND_TAGLINE */.iO
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:description",
                    content: description || lib/* BRAND_DESCRIPTION */.CO
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:image",
                    content: image || lib/* BRAND_IMAGE */.J3
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "twitter:url",
                    content: url || lib/* BRAND_URL */.$1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "twitter:title",
                    content: title || lib/* BRAND_TAGLINE */.iO
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "twitter:description",
                    content: description || lib/* BRAND_DESCRIPTION */.CO
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "twitter:image",
                    content: image || lib/* BRAND_IMAGE */.J3
                })
            ]
        })
    });
};
/* harmony default export */ var Meta = (MetaComponent);

;// CONCATENATED MODULE: ./components/Testimonials.tsx


var Testimonial = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white pt-16 lg:py-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-cyan-600 pb-16 lg:relative lg:z-10 lg:pb-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-8 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative lg:-my-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "aria-hidden": "true",
                                className: "absolute inset-x-0 top-0 h-1/2 bg-white lg:hidden"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:h-full lg:p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "aspect-w-4 aspect-h-6 overflow-hidden rounded-xl shadow-xl sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none lg:h-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "object-cover rounded-xl lg:h-full lg:w-full",
                                        src: "https://res.cloudinary.com/deyudesls/image/upload/v1689383145/rachel.jpg",
                                        alt: "ceo image",
                                        loading: "lazy",
                                        blurDataURL: "https://res.cloudinary.com/deyudesls/image/upload/v1689383145/rachel.jpg",
                                        placeholder: "blur",
                                        layout: "fill"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-12 lg:col-span-2 lg:m-0 lg:pl-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0 lg:py-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-6 text-2xl font-medium text-white",
                                            children: "Knowing the importance of qualify care, I developed an insatiable desire to provide patient centered care that focuses on the wellbeing of each individual, one patient at a time."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                        className: "mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-base font-medium text-white",
                                                children: "Rachel Essel"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-base font-medium text-cyan-100",
                                                children: "CEO at Potterstouch LLC"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Testimonials = (Testimonial);

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/PhoneIcon.js

function PhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
  }));
}
const PhoneIcon_ForwardRef = react.forwardRef(PhoneIcon);
/* harmony default export */ var esm_PhoneIcon = (PhoneIcon_ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/EnvelopeIcon.js

function EnvelopeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
  }));
}
const EnvelopeIcon_ForwardRef = react.forwardRef(EnvelopeIcon);
/* harmony default export */ var esm_EnvelopeIcon = (EnvelopeIcon_ForwardRef);
// EXTERNAL MODULE: ./components/Header.tsx
var Header = __webpack_require__(8969);
// EXTERNAL MODULE: ./components/Footer.tsx
var Footer = __webpack_require__(2980);
;// CONCATENATED MODULE: ./components/Map.tsx

function Map() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto max-w-lg flex-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.0177598169853!2d-82.94984272374967!3d40.097316971492816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8838f52bac59b121%3A0x26c9c83d45857a52!2s2600%20Tiller%20Ln%2C%20Columbus%2C%20OH%2043231%2C%20USA!5e0!3m2!1sen!2sgh!4v1692322755851!5m2!1sen!2sgh",
            className: "w-full h-56 border-0",
            allowFullScreen: true,
            loading: "lazy",
            referrerPolicy: "no-referrer-when-downgrade"
        })
    });
}

;// CONCATENATED MODULE: ./pages/index.tsx












var MAIN_IMAGE = "https://res.cloudinary.com/deyudesls/image/upload/v1692324885/photo-1470116945706-e6bf5d5a53ca_r14ems.webp";
var MID_IMAGE = "https://res.cloudinary.com/deyudesls/image/upload/v1692324930/photo-1565615833231-e8c91a38a012_mrxfuq.webp";
var LAST_IMAGE = "https://res.cloudinary.com/deyudesls/image/upload/v1689647480/photo-1452715923772-3af19799aef8_xqsjic.webp";
var features = [
    {
        name: "In-home Services",
        description: "We offer hands-on assistance with activities such as grooming, ensuring safety, and aiding with independent ambulation, with special attention to the needs of children and elderly.",
        icon: esm_HomeIcon
    },
    {
        name: "Medical Services",
        description: "Our skilled therapies include physical therapy, occupational therapy, and speech-language\n      pathology, which are particularly beneficial for children's development. Our healthcare professionals, including registered nurses and advanced nurse practitioners, provide dedicated care for each patient, regardless of age.",
        icon: esm_BuildingOffice2Icon
    },
    {
        name: "Pediatric and Adult Nursing",
        description: "Our specialized pediatric nurses make regular home visits to ensure the overall well-being of all children under our care. At the same time, our adult nursing staff conducts thorough assessments for adult clients, serving as patient advocates.",
        icon: esm_UsersIcon
    },
    {
        name: "Home Health Aides",
        description: "Our home health aides assist patients of all ages with medication administration, meal preparation, feeding, and light housekeeping. They engage children in fun daily activities, provide companionship, and support adults with everyday tasks.",
        icon: esm_ShieldCheckIcon
    },
    {
        name: "Transportation",
        description: "We provide safe and comfortable rides for school drop-offs, doctors’ appointments, medication pickups, and grocery shopping, with special assistance for wheelchair accessibility.",
        icon: esm_TruckIcon
    },
    {
        name: "Comprehensive Care Coordinator",
        description: "Our care coordinators manage all aspects of patient care, from scheduling children's activities to coordinating adult healthcare appointments. They ensure seamless, coordinated care for all ages, alleviate the stress of managing multiple healthcare needs, and keep family members updated on their loved ones' progress.",
        icon: esm_BellAlertIcon
    }, 
];
var metrics = [
    {
        id: 1,
        stat: "Companionship",
        description: "Tailored to children's needs while being suitable for all age groups."
    },
    {
        id: 2,
        stat: "Cognitive Social Interaction",
        description: "Promoting cognitive development in children and maintaining cognitive health in adults."
    },
    {
        id: 3,
        stat: "Errands",
        description: "Assistance with tasks, with an emphasis on those suitable for children, such as educational errands."
    },
    {
        id: 4,
        stat: "Transportation",
        description: "Safe and reliable transportation services, from school runs to medical appointments."
    },
    {
        id: 5,
        stat: "Medication Pickup",
        description: "Coordinated and secure medication pick-up service, ensuring the health needs of all clients are met."
    },
    {
        id: 6,
        stat: "Meal Prep",
        description: "Preparation of healthy and child-friendly meals, catering to the nutritional needs of all clients."
    },
    {
        id: 7,
        stat: "Light Housekeeping",
        description: "Maintaining a clean and organized environment that's safe for children and comfortable for all clients."
    }, 
];
var footerNavigation = {
    company: [
        {
            name: "About",
            href: "/about"
        }
    ],
    legal: [
        {
            name: "Privacy",
            href: "/privacy"
        },
        {
            name: "Terms",
            href: "terms"
        }, 
    ]
};
function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {
                title: "".concat(lib/* BRAND_NAME */.RS, " | ").concat(lib/* BRAND_TAGLINE */.iO)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative isolate pt-14",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-0 -z-10 h-full w-full object-cover",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: MAIN_IMAGE,
                                            alt: "People working on laptops",
                                            layout: "fill",
                                            sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw",
                                            placeholder: "blur",
                                            className: "absolute inset-0 -z-10 h-full w-full object-cover",
                                            blurDataURL: MAIN_IMAGE
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-2xl py-32 sm:py-48 lg:py-56",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-center m-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-4xl font-bold tracking-tight text-white sm:text-6xl",
                                                    children: "Take control of your health and wellness"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-6 text-lg leading-8 font-bold text-white",
                                                    children: lib/* BRAND_TAGLINE */.iO
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-10 flex items-center justify-center gap-x-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "tel:13476540706",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "flex items-center cursor justify-center rounded-md border border-transparent bg-white px-4 py-3 text-base font-medium text-cyan-700 shadow-sm hover:bg-cyan-50 sm:px-8",
                                                                children: "Call Us"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://api.whatsapp.com/send?phone=13476540706",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "flex items-center justify-center rounded-md border border-transparent bg-cyan-500 bg-opacity-60 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-opacity-70 sm:px-8",
                                                                children: "Text on WhatsApp"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]",
                                            style: {
                                                clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-gray-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-center text-3xl font-bold text-gray-900",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-cyan-600 to-cyan-600",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckCircleIcon, {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center text-base font-semibold text-gray-500 uppercase",
                                            children: "Trusted by all who use our services"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center text-lg text-gray-500",
                                            children: "PottersTouch is committed to providing the best possible care for your loved ones. We specialize in offering top-tier, child-focused care and transportation services, and we’re trusted by families across Ohio. With a gentle and compassionate approach, we’re here to ensure the safety and wellness of those under our care."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative overflow-hidden pt-16 pb-32",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-gray-100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-flow-col lg:grid-cols-2 lg:gap-24",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "py-16 lg:mx-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-r from-cyan-600 to-cyan-600",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_InformationCircleIcon, {
                                                                        className: "h-6 w-6 text-white",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mt-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                        className: "text-3xl font-bold tracking-tight text-gray-900",
                                                                        children: "What we do"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "mt-4 text-lg text-gray-500",
                                                                        children: "At PottersTouch LLC, we are passionate about providing top-tier, child-focused post-acute, long-term care, and transportation services. Our core mission is to deliver excellent clinical and transport solutions with a gentle, compassionate approach. While our primary focus is on children's healthcare, our services cater to all age groups. We strive to foster an environment of safety, healing, and comprehensive wellness for every client."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-12 sm:mt-16 lg:mt-0 relative h-64 lg:h-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-full pl-4 sm:pl-6 lg:px-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "w-full h-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 object-cover",
                                                            src: MID_IMAGE,
                                                            alt: "Inbox user interface",
                                                            loading: "lazy",
                                                            blurDataURL: MID_IMAGE,
                                                            placeholder: "blur",
                                                            layout: "fill"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-gradient-to-r from-cyan-800 to-cyan-700",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:px-8 lg:pt-24",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-3xl font-bold tracking-tight text-white",
                                            children: "What we offer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 max-w-3xl text-lg text-cyan-200",
                                            children: "We offer a wide range of services to meet the needs of our clients."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16",
                                            children: features.map(function(feature) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "flex h-12 w-12 items-center justify-center rounded-md bg-white bg-opacity-10",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                                    className: "h-6 w-6 text-white",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "text-lg font-medium text-white",
                                                                    children: feature.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "mt-2 text-base text-white",
                                                                    children: feature.description
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, feature.name);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative bg-gray-900",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-x-0 bottom-0 h-80 xl:top-0 xl:h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full w-full xl:grid xl:grid-cols-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "h-full xl:relative xl:col-start-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "h-full w-full object-cover opacity-25 xl:absolute xl:inset-0",
                                                        src: LAST_IMAGE,
                                                        alt: "People working on laptops",
                                                        loading: "lazy",
                                                        blurDataURL: LAST_IMAGE,
                                                        placeholder: "blur",
                                                        layout: "fill"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        "aria-hidden": "true",
                                                        className: "absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-4xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-12 xl:gap-x-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-span-8 xl:pb-24",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-base font-semibold",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "bg-gradient-to-r from-cyan-300 to-cyan-300 bg-clip-text text-transparent",
                                                        children: "Daily Activities"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-3 text-3xl font-bold tracking-tight text-white",
                                                    children: "We specialize in organizing a wide range of daily activities, tailored for the enrichment of our young clients. While our focus is children, we cater to all age groups. Our activities include:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2",
                                                    children: metrics.map(function(item) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "block text-2xl font-bold text-white",
                                                                    children: item.stat
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "text-white",
                                                                    children: item.description
                                                                })
                                                            ]
                                                        }, item.id);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-4xl py-16 px-4 sm:px-6 sm:py-24 lg:flex lg:max-w-7xl lg:items-center lg:justify-between lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block",
                                                children: "Round-the-clock support?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "-mb-1 block bg-gradient-to-r from-cyan-600 to-cyan-600 bg-clip-text pb-1 text-transparent",
                                                children: "We provide 24/7 support all year round."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8 flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mx-auto max-w-lg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight",
                                                        children: "Visit Us"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-lg text-gray-500",
                                                            children: "2600 Tiller lane suite c5 Columbus ohio 43231"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-9",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PhoneIcon, {
                                                                            className: "h-6 w-6 text-gray-400",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "ml-3 text-base text-gray-500",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: "tel:16145566978",
                                                                                    children: "+1 740-819-1553"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: "tel:13476540706",
                                                                                    children: "+1 347-654-0706"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "mt-1",
                                                                                children: "Mon-Fri 8am to 6pm EST"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mt-6 flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_EnvelopeIcon, {
                                                                            className: "h-6 w-6 text-gray-400",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "ml-3 text-base text-gray-500",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "mailto:".concat(lib/* BRAND_EMAIL */.m4, "?subject=Hello%20PottersTouch"),
                                                                                children: lib/* BRAND_EMAIL */.m4
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [151,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);